import { render, staticRenderFns } from "./omt-input.vue?vue&type=template&id=3ec4b5cc&scoped=true&"
import script from "./omt-input.vue?vue&type=script&lang=js&"
export * from "./omt-input.vue?vue&type=script&lang=js&"
import style0 from "./omt-input.vue?vue&type=style&index=0&id=3ec4b5cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec4b5cc",
  null
  
)

export default component.exports